export enum PayPalFunding {
    Card,
    Credit,
    Elv
}
